import { SUBSCRIPTION_UPDATE_EVENT } from 'contexts/SubscriptionContext';

/**
 * Triggers a subscription update event to refresh the subscription status
 * This should be called after login or any other action that might change the subscription status
 */
export const triggerSubscriptionUpdate = () => {
  console.log('Triggering subscription update event');
  window.dispatchEvent(new Event(SUBSCRIPTION_UPDATE_EVENT));
};

export default {
  triggerSubscriptionUpdate
};
